import React from 'react';

interface IconProps {
    width?: string;
    height?: string;
    fill?: string;
    secondaryfill?: string;
}

const Bars3BottomRight: React.FC<IconProps> = ({
    width = '24',
    height = '24',
    fill = 'currentColor',
    secondaryfill
}) => {
    return (
        <svg height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg">
            <g fill={fill}>
                <defs />
                <path className="cls-1" d="M263 351.92h534" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
                <path className="cls-1" d="M263 530.24h534" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
                <path className="cls-1" d="M590 708h207" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
            </g>
        </svg>
    );
};

export default Bars3BottomRight;
